{
  "loading": "טוען...",
  "placeholder": "בחר אפשרות..."
}